import React, { FC } from 'react';
import ExpenseCategoryFormField from './ExpenseCategoryFormField';

const CapExCategoryFormField: FC<any> = (props): React.ReactElement => {
	return <ExpenseCategoryFormField categoryType="capex" {...props} />;
};

export default CapExCategoryFormField;
